const styles = (theme) => ({
  root: {},
  right: {
    textAlign: 'right',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: '-3px',
    },
  },
  bold: {
    fontWeight: 600,
  },
  readIcon: {
    color: theme.palette.border.light,
  },
  unreadIcon: {
    color: theme.palette.primary.dark,
  },
  row: {
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.border.light}`,
      marginBottom: '16px',
    },
  },
  letterTitle: {
    paddingLeft: theme.spacing.unit,
  },
});

export default styles;
